// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"764":"f41b8257","887":"58d2850b","898":"a369c8d3"}[chunkId] + ".chunk.js";
};